module.exports = __webpack_public_path__ + "img/IMG_2508-2.39bf36cf.jpg";